import { createApi } from '@reduxjs/toolkit/query/react';
import { baseApiQuery } from '../basequery';

export const ROLES = Object.freeze({
  VIEW_ONLY: 'ViewOnly',
  USER: 'User',
  REVIEWER: 'Reviewer',
  QL: 'QL',
  ADMIN: 'Admin',
});
export type UserRole = (typeof ROLES)[keyof typeof ROLES];

export interface Me {
  oid: string;
  name: string;
  email: string;
  scopes: string[];
  roles: UserRole[];
}

export interface GetMeResponse {
  data: Me;
}

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseApiQuery,
  tagTypes: ['Me'],
  endpoints: (builder) => ({
    getMe: builder.query<Partial<GetMeResponse>, void>({
      query: () => ({ url: '/me', method: 'GET' }),
      providesTags: ['Me'],
    }),
  }),
});

export const { useGetMeQuery, useLazyGetMeQuery } = userApi;
